import { css } from '@linaria/core'
import { style } from '#styles/index'

export const partPeriodInputClass = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 4px 8px;
  border: 1px solid ${style.themeColors.lineInput};
  min-height: 30px;
  font-size: inherit;

  color: ${style.themeColors.textDefault};
  background-color: ${style.themeColors.backgroundDefault};
  outline: 2px solid transparent;
  transition: 0.25s ease border-color, 0.25s ease outline-color, 0.25s ease color;
  outline-offset: -2px;

  &._disabled {
    pointer-events: none;
    background-color: ${style.themeColors.backgroundBoxed};
    border-color: ${style.themeColors.textDeselected};
    
    > ._icon {
      background-color: ${style.themeColors.textDeselected};
    }
  }
  
  &:hover {
    border-color: ${style.themeColors.lineInputHover}
  }

  &:focus {
    outline-color: ${style.themeColors.lineFocus};
    border-color: ${style.themeColors.lineFocus};
  }
  
  > ._period {
    font-variant: tabular-nums;
  }
  
  > ._icon {
    background-color: ${style.themeColors.textDimmed};
  }
`
